import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "product-header-wrapper" };
const _hoisted_2 = { class: "toolbar-wrapper" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "toolbar" };
const _hoisted_5 = { class: "toolbar__left" };
const _hoisted_6 = { class: "container" };
const _hoisted_7 = {
    class: "product-hero",
    role: "region",
    "aria-labelledby": "product-title"
};
const _hoisted_8 = { class: "product-hero__media" };
const _hoisted_9 = { class: "product-hero__slideshow" };
const _hoisted_10 = ["src"];
const _hoisted_11 = { class: "product-hero__image-frame" };
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
    key: 0,
    class: "product-hero__actions"
};
const _hoisted_15 = { class: "product-hero__info" };
const _hoisted_16 = {
    id: "product-title",
    class: "product-hero__title"
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
    key: 0,
    class: "product-hero__specifications"
};
const _hoisted_19 = { class: "product-hero__spec-list" };
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = {
    key: 1,
    class: "product-hero__oem-section"
};
const _hoisted_22 = { class: "product-hero__oem-buttons" };
const _hoisted_23 = { class: "product-hero__pack-table" };
const _hoisted_24 = { class: "pack-table" };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { class: "pack-table__code" };
const _hoisted_27 = { key: 1 };
const _hoisted_28 = { class: "pack-table__code" };
const _hoisted_29 = { key: 2 };
const _hoisted_30 = { class: "pack-table__code" };
const _hoisted_31 = { key: 3 };
const _hoisted_32 = { class: "pack-table__code" };
import { ref, onUnmounted, computed, onMounted } from 'vue';
import { useAssets } from '../composables/useAssets';
import { useProductActions } from '../composables/useProductActions';
import OutlineButton from './ui/OutlineButton.vue';
const VEHICLE_KEY = 'selectedVehicleId';
const LICENCE_PLATE_KEY = 'selectedLicencePlate';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Product',
    props: {
        product: {}
    },
    setup(__props) {
        const { assetUrl } = useAssets();
        const { share, cleanup } = useProductActions();
        const props = __props;
        const recommendedLicencePlate = ref('');
        const recommenedVehicleId = ref(null);
        // Use OEM approvals from product data
        const oemApprovals = computed(() => {
            return props.product.oem_approvals || [];
        });
        // Image carousel (Splide)
        const splideRef = ref(null);
        const productImages = computed(() => {
            return [
                props.product.image_1l,
                props.product.image_5l,
                props.product.image_20l,
                props.product.image_199l
            ].filter(Boolean);
        });
        const splideOptions = {
            type: 'loop',
            perPage: 1,
            arrows: false,
            pagination: false,
            drag: true,
            rewind: true
        };
        const goPrev = () => {
            if (splideRef.value?.splide) {
                splideRef.value.splide.go('<');
            }
        };
        const goNext = () => {
            if (splideRef.value?.splide) {
                splideRef.value.splide.go('>');
            }
        };
        /** Same rules as RecommendationPdfPresenter::parseRecommendedUsageSpecs (first token bold; split on ; / newline / br). */
        const parseRecommendedUsageSpecs = (html) => {
            if (html == null || String(html).trim() === '') {
                return [];
            }
            let clean = String(html).replace(/<[^>]*>/g, ' ');
            clean = clean.replace(/\u00a0/g, ' ');
            const parts = clean.split(/[;\n\r]+|<br\s*\/?>/i);
            const out = [];
            for (const part of parts) {
                const trimmed = part.replace(/\s+/g, ' ').trim();
                if (trimmed === '') {
                    continue;
                }
                const m = trimmed.match(/^(\S+)\s*(.*)$/);
                if (m) {
                    out.push({ bold: m[1], regular: m[2].trim() });
                }
            }
            return out;
        };
        const splitUsageRegularByPipe = (regular) => {
            const t = regular.trim();
            if (t === '') {
                return [];
            }
            return t.split(/\s*\|\s*/).map((p) => p.trim()).filter((p) => p !== '');
        };
        const recommendedSpec = computed(() => props.product.recommended_use_product_detail_page ?? '');
        const hasRecommendedSpecs = computed(() => recommendedSpec.value.length > 0);
        const showBackToRecommendedProductsButton = ref(false);
        const goBackToRecommendedResults = () => {
            localStorage.setItem('isReturningToResults', 'true');
            if (recommenedVehicleId.value) {
                localStorage.setItem(VEHICLE_KEY, recommenedVehicleId.value.toString());
            }
            if (recommendedLicencePlate.value) {
                localStorage.setItem(LICENCE_PLATE_KEY, recommendedLicencePlate.value);
            }
            window.location.href = '/find-my-oil';
        };
        const backToProducts = () => {
            window.location.href = '/products';
        };
        onMounted(() => {
            if (document.referrer.includes('/find-my-oil') && (localStorage.getItem(VEHICLE_KEY) || localStorage.getItem(LICENCE_PLATE_KEY))) {
                showBackToRecommendedProductsButton.value = true;
                if (localStorage.getItem(VEHICLE_KEY)) {
                    recommenedVehicleId.value = Number(localStorage.getItem(VEHICLE_KEY));
                    localStorage.removeItem(VEHICLE_KEY);
                }
                if (localStorage.getItem(LICENCE_PLATE_KEY)) {
                    recommendedLicencePlate.value = String(localStorage.getItem(LICENCE_PLATE_KEY));
                    localStorage.removeItem(LICENCE_PLATE_KEY);
                }
            }
            else {
                if (localStorage.getItem(VEHICLE_KEY)) {
                    localStorage.removeItem(VEHICLE_KEY);
                }
                if (localStorage.getItem(LICENCE_PLATE_KEY)) {
                    localStorage.removeItem(LICENCE_PLATE_KEY);
                }
            }
        });
        onUnmounted(() => {
            cleanup();
        });
        return (_ctx, _cache) => {
            const _component_SplideSlide = _resolveComponent("SplideSlide");
            const _component_Splide = _resolveComponent("Splide");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                (showBackToRecommendedProductsButton.value)
                                    ? (_openBlock(), _createBlock(OutlineButton, {
                                        key: 0,
                                        label: "BACK TO RECOMMENDED PRODUCTS",
                                        icon: _unref(assetUrl)('/images/trade-site/back-arrow.svg'),
                                        action: goBackToRecommendedResults
                                    }, null, 8, ["icon"]))
                                    : (_openBlock(), _createBlock(OutlineButton, {
                                        key: 1,
                                        label: "BACK TO PRODUCTS",
                                        icon: _unref(assetUrl)('/images/trade-site/back-arrow.svg'),
                                        href: "/products"
                                    }, null, 8, ["icon"]))
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("section", _hoisted_7, [
                        _createElementVNode("aside", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                (productImages.value.length > 1)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "product-hero__nav product-hero__nav--prev",
                                        onClick: goPrev,
                                        "aria-label": "Previous image"
                                    }, [
                                        _createElementVNode("img", {
                                            src: _unref(assetUrl)('/images/trade-site/arrow-gallery-thin.svg'),
                                            alt: "Previous"
                                        }, null, 8, _hoisted_10)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_11, [
                                    (productImages.value.length > 0)
                                        ? (_openBlock(), _createBlock(_component_Splide, {
                                            key: 0,
                                            ref_key: "splideRef",
                                            ref: splideRef,
                                            options: splideOptions,
                                            class: "product-hero__splide"
                                        }, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productImages.value, (image, index) => {
                                                    return (_openBlock(), _createBlock(_component_SplideSlide, { key: index }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("img", {
                                                                src: image,
                                                                alt: __props.product.title,
                                                                class: "product-hero__image"
                                                            }, null, 8, _hoisted_12)
                                                        ]),
                                                        _: 2
                                                    }, 1024));
                                                }), 128))
                                            ]),
                                            _: 1
                                        }, 512))
                                        : _createCommentVNode("", true)
                                ]),
                                (productImages.value.length > 1)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "product-hero__nav product-hero__nav--next",
                                        onClick: goNext,
                                        "aria-label": "Next image"
                                    }, [
                                        _createElementVNode("img", {
                                            src: _unref(assetUrl)('/images/trade-site/arrow-gallery-thin.svg'),
                                            alt: "Next"
                                        }, null, 8, _hoisted_13)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            (__props.product.technical_data_sheet || __props.product.safety_data_sheet)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    (__props.product.technical_data_sheet)
                                        ? (_openBlock(), _createBlock(OutlineButton, {
                                            key: 0,
                                            label: "Technical Data Sheet",
                                            icon: _unref(assetUrl)('/images/trade-site/share-link-icon.svg'),
                                            href: __props.product.technical_data_sheet
                                        }, null, 8, ["icon", "href"]))
                                        : _createCommentVNode("", true),
                                    (__props.product.safety_data_sheet)
                                        ? (_openBlock(), _createBlock(OutlineButton, {
                                            key: 1,
                                            label: "Safety Data Sheet",
                                            icon: _unref(assetUrl)('/images/trade-site/share-link-icon.svg'),
                                            href: __props.product.safety_data_sheet
                                        }, null, 8, ["icon", "href"]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("h1", _hoisted_16, [
                                _createTextVNode(_toDisplayString(__props.product.code) + " ", 1),
                                _createElementVNode("span", {
                                    class: "product-hero__badge",
                                    style: _normalizeStyle(`background: ${__props.product.hexcode}`)
                                }, _toDisplayString(__props.product.title), 5)
                            ]),
                            _createElementVNode("div", {
                                class: "product-hero__desc",
                                innerHTML: __props.product.description
                            }, null, 8, _hoisted_17),
                            (hasRecommendedSpecs.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "product-hero__section-title" }, "Recommended for use in vehicles requiring:", -1)),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", { innerHTML: recommendedSpec.value }, null, 8, _hoisted_20)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (oemApprovals.value && oemApprovals.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "product-hero__oem-title" }, "OEM Approvals:", -1)),
                                    _createElementVNode("div", _hoisted_22, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oemApprovals.value, (approval, index) => {
                                            return (_openBlock(), _createBlock(OutlineButton, {
                                                key: `oem-${index}`,
                                                label: approval.label,
                                                icon: _unref(assetUrl)('/images/trade-site/share-link-icon.svg'),
                                                href: approval.pdf_url,
                                                class: "btn-oem"
                                            }, null, 8, ["label", "icon", "href"]));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("table", _hoisted_24, [
                                    _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", { class: "pack-table__header left" }, "Part number:"),
                                            _createElementVNode("th", { class: "pack-table__header right" }, "Pack size:")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (__props.product.code_1l)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                                                _createElementVNode("td", _hoisted_26, _toDisplayString(__props.product.code_1l), 1),
                                                _cache[2] || (_cache[2] = _createElementVNode("td", { class: "pack-table__size" }, "1L", -1))
                                            ]))
                                            : _createCommentVNode("", true),
                                        (__props.product.code_5l)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                                                _createElementVNode("td", _hoisted_28, _toDisplayString(__props.product.code_5l), 1),
                                                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "pack-table__size" }, "5L", -1))
                                            ]))
                                            : _createCommentVNode("", true),
                                        (__props.product.code_20l)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                                                _createElementVNode("td", _hoisted_30, _toDisplayString(__props.product.code_20l), 1),
                                                _cache[4] || (_cache[4] = _createElementVNode("td", { class: "pack-table__size" }, "20L", -1))
                                            ]))
                                            : _createCommentVNode("", true),
                                        (__props.product.code_199l)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                                _createElementVNode("td", _hoisted_32, _toDisplayString(__props.product.code_199l), 1),
                                                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "pack-table__size" }, "199L", -1))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
